<template>
  <div class="dialogBox">
    <el-dialog
      title="错误信息"
      :visible.sync="errorMessageVisible"
      width="30%"
      @closed="errorMessageClosed"
    >
      <!-- 消息信息 -->
      <div class="messageBox">
        成功添加（更新）<span style="color: green">{{ successCount }}</span
        >名考生，失败<span style="color: red">{{ failCount }}</span
        >名考生。错误信息如下：
        <el-button type="primary" @click="downloadErrorInfo" :loading="loading"
          >下载错误信息</el-button
        >
      </div>
      <!-- 表格内容 -->
      <div class="t_table">
        <el-table
          ref="table"
          :data="getData"
          :row-class-name="tableRowClassName"
          :row-key="getRowKeyOfTarget"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
          }"
        >
          <el-table-column label="序号" type="index" width="60" align="center"
            ><template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机号" align="center"
            ><template slot-scope="scope">
              {{ scope.row.Telephone }}
            </template>
          </el-table-column>
          <el-table-column label="账号" align="center"
            ><template slot-scope="scope">
              {{ scope.row.UserName }}
            </template>
          </el-table-column>

          <el-table-column label="姓名" align="center"
            ><template slot-scope="scope">
              {{ scope.row.RealName }}
            </template>
          </el-table-column>

          <el-table-column label="失败原因" align="center"
            ><template slot-scope="scope">
              {{ scope.row.Reason }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="pagesizesArr"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            class="pagination"
          ></el-pagination>
        </div>
      </div>
      <!-- 底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="errorMessageVisible = false">取 消</el-button>
        <el-button type="primary" @click="errorMessageVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      // 弹窗吊起定义
      errorMessageVisible: false,
      // 消息数据
      successCount: 0,
      failCount: 0,
      // 表格数据
      allData: [],
      getData: [],
      currentPage: 1,
      pageSize: 5,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 0,
      loading: false,
      formColumns: [
        {
          prop: "index",
          label: "序号",
        },
        {
          prop: "Telephone",
          label: "手机号",
        },
        {
          prop: "UserName",
          label: "账号",
        },
        {
          prop: "Reason",
          label: "失败原因",
        },
      ],
    };
  },
  methods: {
    // 弹窗关闭触发
    errorMessageClosed() {
      this.currentPage = 1;
      this.pageSize = 5;
    },
    // 列表数据
    getDataList() {
      this.getData = [];
      let start = (this.currentPage - 1) * this.pageSize;
      for (let index = start; index < this.allData.length; index++) {
        const element = this.allData[index];
        if (index == start + this.pageSize) {
          break;
        }
        this.getData.push(element);
      }
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.index;
    },
    // 每页大小改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getDataList();
    },
    // 切换页数后触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getDataList();
    },
    // 下载错误信息
    downloadErrorInfo() {
      this.loading = true;
      this.$confirm("此操作将下载错误信息该文件, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let newarr = this.allData.map((item=>{
        const obj = {
          '序号':item.index,
          '手机号':item.Telephone,
          '账号':item.UserName,
          '失败原因':item.Reason,
        }
        return obj
      }))
      const worksheet = XLSX.utils.json_to_sheet(newarr);
          // 创建一个新的工作簿
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          // 生成Excel文件的二进制数据
          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });
          // 将二进制数据转换为Blob对象
          const blob = new Blob([excelBuffer], {
            type: "application/octet-stream",
          });
          // 使用file-saver保存文件
          saveAs(blob, "错误信息.xlsx");
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .catch(() => {
          setTimeout(() => {
            this.loading = false;
            this.$message({
              type: "info",
              message: "已取消",
            });
          }, 500);
        });
    },
  },
};
</script>

<style lang='scss' scoped>
// 弹窗整体css
.dialogBox {
  box-sizing: border-box;
  ::v-deep .el-dialog {
    width: 774px !important;
    background: #ffffff;
    opacity: 1;
    border-radius: 5px;
    .el-dialog__header {
      height: 55px;
      background: linear-gradient(
        180deg,
        #64b5ff 0%,
        rgba(199, 228, 255, 1) 100%
      );
      opacity: 1;
      border-radius: 5px 5px 0px 0px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    .el-dialog__body {
      padding: 0px 20px;
    }
    .el-dialog__footer {
      text-align: center;
      margin-top: 10px;
      margin-bottom: 30px;
      .el-button {
        width: 120px;
        height: 50px;
        opacity: 1;
        border-radius: 4px;
        margin-left: 0px;
        margin-right: 100px;
      }
    }
  }
}

.messageBox {
  font-family: PingFang SC;
  font-size: 21px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

// 表格
.t_table {
  margin-top: 14px;
  width: 100%;
}

// 右边表格-斑马纹
::v-deep .el-table .warning-row {
  background: #fff !important;
}

// 右边表格-斑马纹
::v-deep .el-table .success-row {
  background: #f8fcff !important;
}

// 右边表格-列表操作按钮
.operation_box {
  width: 260px;
  text-align: center;
  margin: 0 auto;
  .el-button {
    font-size: 16px;
    margin-left: 0px;
    margin-right: 15px;
  }
}

// 分页
.foot_box {
  position: relative;
  height: 88px;
  .foot_pagetions {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
    .pagination {
      ::v-deep .el-pager {
        li {
          border: 1px solid #d9d9d9;
          margin-right: 8px;
          &.active {
            color: #ffffff;
            background-color: #409eff;
            border: none;
          }
        }
      }
      ::v-deep .el-pagination__jump {
        margin: 0px 10px 0px 0px !important;
      }
    }
  }
}
</style>